export default "__VITE_ASSET__b59a196f__"